import { user as types, request as HTTP_REQUEST } from '../../constants/types';
import { requestAxios } from './helpers';

const _request = async (path, dispatch, type = HTTP_REQUEST.GET, body = {}, config = {}) => {
    dispatch(setLoading());
    try {
        const response = await requestAxios(type, path, body, config);
        dispatch(setError(null))
        const { data } = response;
        if (data instanceof Array)
            dispatch({ type: types.GET, payload: data })
        else if (data instanceof Object) {
            const { user, token: { auth, refresh } } = data;
            if (type === HTTP_REQUEST.POST) {
                localStorage.setItem('AUTHORIZATION_TOKEN_BLOG', auth);
                localStorage.setItem('REFRESH_TOKEN_BLOG', refresh);
                localStorage.setItem('user', JSON.stringify(user));
                dispatch({ type: types.PUSH, payload: user })
            }
            else dispatch({ type: types.USER, payload: user })
        }
    } catch (error) {
        const { message } = error?.response?.data || error;
        dispatch(setError(message))
    }
    dispatch(setLoading());
}
export const setUser = user => dispatch => {
    dispatch({
        type: types.USER,
        payload: user
    });
}
export const setLoading = () => dispatch => {
    dispatch({ type: types.LOADING });
}
export const setError = error => dispatch => {
    dispatch({
        type: types.ERROR,
        payload: error
    });
}
export const listAllUsers = async () => async dispatch => {
    await _request('', dispatch);
}
export const listAllUsersByName = name => async dispatch => {
    const config = { params: { name } };
    await _request('/search', dispatch, config);
}
export const findUserByEmail = email => async dispatch => {
    const config = { params: { email } };
    await _request('/find', dispatch, config);
}
export const registerUserAndLogin = () => async (dispatch, getState) => {
    const { auth: { login }, user: { user }, role:{role}, address: {address} } = getState();
    await _request('/user', dispatch, HTTP_REQUEST.POST, { ...user, login, role, address }); 
}
